import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "desktop-content display--flex justify--space-between align--center width--page-size" }
const _hoisted_2 = { class: "display--flex justify--space-between" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DesktopBarLink = _resolveComponent("DesktopBarLink")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["desktop-bar display--flex justify--center width--full", {
        'bg--pink': _ctx.hasActiveEvent,
        'bg--white': !_ctx.hasActiveEvent
    }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.links, (link, index) => {
          return (_openBlock(), _createBlock(_component_DesktopBarLink, {
            link: link,
            key: index
          }, null, 8, ["link"]))
        }), 128))
      ]),
      _createElementVNode("div", null, [
        _createVNode(_component_router_link, { to: "/#header" }, {
          default: _withCtx(() => [
            _createElementVNode("span", {
              class: _normalizeClass(["title--large", {
                        'text--white': _ctx.hasActiveEvent
                    }])
            }, " SnapShare ", 2)
          ]),
          _: 1
        })
      ])
    ])
  ], 2))
}